import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=d693f0bc&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=ts"
export * from "./NotificationsList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=d693f0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d693f0bc",
  null
  
)

export default component.exports